
export const root = {
    borderRadius: '0.25rem',
    width: '1.25rem',
    height: '1.25rem',
    background: 'transparent',
    checkedBackground: '{primary.color}',
    checkedHoverBackground: '{primary.hover.color}',
    disabledBackground: '{form.field.disabled.background}',
    filledBackground: 'transparent',
    borderColor: '{surface.400}',
    borderWidth: '2px',
    hoverBorderColor: '{primary.color}',
    focusBorderColor: '{primary.color}',
    checkedBorderColor: '{primary.color}',
    checkedHoverBorderColor: '{primary.hover.color}',
    checkedFocusBorderColor: '{primary.color}',
    checkedDisabledBorderColor: '{form.field.border.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    shadow: 'none',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: '{focus.ring.shadow}'
    },
    transitionDuration: '{form.field.transition.duration}',
    sm: {
        width: '1rem',
        height: '1rem'
    },
    lg: {
        width: '1.5rem',
        height: '1.5rem'
    }
};

export const icon = {
    size: '0.75rem',
    color: '{form.field.color}',
    checkedColor: 'white',
    checkedHoverColor: 'white',
    disabledColor: '{form.field.disabled.color}',
    sm: {
        size: '0.625rem'
    },
    lg: {
        size: '1rem'
    }
};

export default {
    root,
    icon
};
